// Visually-hidden utility (tailwind): .sr-only { position:absolute; width:1px; height:1px; margin:-1px; overflow:hidden; clip:rect(0 0 0 0); }
import React from 'react';

const Announcer: React.FC = () => (
    <div
        id="sr-announcer"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
    />
);

export default Announcer;
